import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, useMediaQuery, createTheme } from '@mui/material';

import styles from './Layout.module.scss'; // SCSS module for layout
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}


const getTheme = (darkMode: boolean) =>
  createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: darkMode ? '#90CAF9' : '#6200EE',
      },
      background: {
        default: darkMode ? '#121212' : '#F8F9FF',
        paper: darkMode ? '#1E1E1E' : '#ffffff',
      },
    },
  });

const Layout: React.FC<LayoutProps> = ({ children }) => {

  const [darkMode, setDarkMode] = useState(false);
  const currentTheme = getTheme(darkMode);
  const isSmallScreen = useMediaQuery(currentTheme.breakpoints.down('sm'));
  const [open, setOpen] = useState(true); // State for sidebar open/close

  useEffect(() => {
    setOpen(!isSmallScreen);
  }, [isSmallScreen]);

  const handleDrawerToggle = () => {
    setOpen(!open);
    localStorage.setItem('sidebarOpen', JSON.stringify(!open));
  };

  const handleThemeToggle = () => {
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    const sidebarOpen = localStorage.getItem('sidebarOpen');
    if (sidebarOpen) {
      setOpen(JSON.parse(sidebarOpen));
    }
  }, []);


  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline /> {/* Applies base Material-UI styles */}
      <Box sx={{ display: 'flex' }}>
        <Header
          handleDrawerToggle={handleDrawerToggle}
          open={open}
          darkMode={darkMode}
          handleThemeToggle={handleThemeToggle}
        />
        <Sidebar open={open} handleDrawerToggle={handleDrawerToggle} />
        <Box
          component="main"
          className={styles.mainContent}
          sx={{
            flexGrow: 1,
            p: 0,
            transition: 'margin-left 0.3s ease',

          }}
        >
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;